import React from 'react'
import createUseStyles, { StyleFunc } from './createUseStyles'

/**
 * Returns a React component styled by the provided style function
 * @param element native html element name
 * @param styles style function exported from element package
 * @param mapPropsToAttrs function to map props to native attributes
 */
export default function createComponent<P, T>(
  element: string,
  styles: StyleFunc,
  mapPropsToAttrs?: (props: any, classes: any) => React.AllHTMLAttributes<P> | undefined,
) {
  const useStyles = createUseStyles(styles, element)
  const component = React.memo(
    React.forwardRef<P, Omit<React.AllHTMLAttributes<P>, keyof T> & T>(
      // @ts-ignore
      ({ children, ...props }, ref) => {
        const classes = useStyles()
        return React.createElement(
          element,
          {
            ref,
            ...(mapPropsToAttrs && mapPropsToAttrs(props, classes)),
          },
          children,
        )
      },
    ),
  )
  component.displayName = `🛫${element}🚀`
  return component
}
